import { useState, useContext } from 'react'
import Section from './_Section'
import { transformPaddingToTailwind } from '../../helpers/style'
import { MarkupContext } from '../../providers/Markup'
import { ChevronRightIcon } from '@heroicons/react/24/solid'

function WayFinder(props) {
  const { createMarkup } = useContext(MarkupContext)
  const [role, setRole] = useState('')
  const [topic, setTopic] = useState('')
  const componentPadding = transformPaddingToTailwind(props.componentPadding)

  const targetPage = props.targetPage ?? '/search'
  const searchButtonLabel = props.cta_name ?? 'Search'
  const inputPlaceholder = props.input_placeholder ?? 'e.g. workforce news, training...'

  const roleOptions = (props.roles ?? []).map((r) => ({
    value: r,
    label: r,
  }))

  const handleSubmit = (e) => {
    e.preventDefault()
    const params = new URLSearchParams()
    if (topic) params.set('q', topic.trim())
    if (role) params.set('audience', role)
    window.location.href = `${targetPage}?${params.toString()}`
  }

  const inputClasses =
    'w-full min-h-[44px] px-4 py-2 rounded !text-(--sb-search-input-text-color) bg-white border border-gray-300 ' +
    'text-sm font-light leading-5 !placeholder:text-(--sb-search-input-text-color) placeholder:text-sm placeholder:font-light placeholder:leading-5 ' +
    'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E3AA45] ' +
    'appearance-none cursor-pointer transition-shadow'

  const labelClasses = 'block font-medium mb-2 text-lg leading-7 text-(--text-color)'

  return (
    <Section
      type="wayfinderComponent"
      outerClass={componentPadding}
      sectionTitle={false}
      innerClass="flex flex-col lg:flex-row lg:items-end gap-6 lg:gap-12"
      {...props}
    >
      {props.title && (
        <div className="lg:flex-shrink-0">
          <div
            id="wayfinder-heading"
            className="text-4xl lg:text-5xl font-light tracking-normal mb-0 font-highlight"
            data-rte="true"
            dangerouslySetInnerHTML={createMarkup(props.title)}
          />
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        aria-labelledby="wayfinder-heading"
        className="flex flex-col lg:flex-row lg:items-end w-full gap-4 lg:gap-6 lg:w-2/3"
      >
        {roleOptions.length > 0 && (
          <div className="flex-1 w-full relative">
            <label htmlFor="wayfinder-role" className={labelClasses}>
              I am a
            </label>
            <div className="relative">
              <select
                id="wayfinder-role"
                name="role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className={`${inputClasses} bg-none`}
                required
              >
                <option value="" disabled hidden>
                  Select a role...
                </option>
                {roleOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-5 h-5"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        )}

        <div className="flex-1 w-full relative">
          <label htmlFor="wayfinder-topic" className={labelClasses}>
            looking for
          </label>
          <input
            id="wayfinder-topic"
            type="text"
            name="topic"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder={inputPlaceholder}
            autoComplete="off"
            className={inputClasses}
          />
        </div>

        <div className="flex flex-col w-full lg:w-auto">
          <span aria-hidden="true" className={`${labelClasses} invisible select-none`}>
            &nbsp;
          </span>
          <button
            type="submit"
            className="w-full lg:w-auto min-h-[44px] px-8 py-2.5 bg-nds-orange hover:bg-nds-orange !text-(--color-secondary-text) !font-medium text-sm leading-5 rounded flex items-center gap-1.5 justify-between lg:justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-(--bg-color) focus:ring--nds-orange"
          >
            <span>{searchButtonLabel}</span>
            <ChevronRightIcon className="w-5 h-5 text-(--color-secondary-text)" />
          </button>
        </div>
      </form>
    </Section>
  )
}

export default WayFinder
